module.exports = __webpack_public_path__ + "assets/img/5ed96f5e9be2c21bea5dc9293396860a.svg";